import React from 'react';
import { Box, Typography } from '@mui/material';

/** 별도 첨부·목차 등과 동일한 영역 헤더 배경 */
export const SEND_SECTION_HEADER_BG = 'rgba(0, 0, 0, 0.02)';

/** MuiDivider / 섹션 borderColor: 'divider' 와 동일 */
export const SEND_SECTION_BORDER_COLOR = 'rgba(0, 0, 0, 0.12)';

/** 서식 옵션 선택 시 배경·테두리(엷은 하늘색) */
export const FORMAT_OPTION_SELECTED_BG = 'rgba(25, 118, 210, 0.08)';
export const FORMAT_OPTION_SELECTED_BG_HOVER = 'rgba(25, 118, 210, 0.12)';
export const FORMAT_OPTION_SELECTED_BORDER = 'rgba(25, 118, 210, 0.45)';
/** 선택 시 텍스트 — primary 계열 */
export const FORMAT_OPTION_SELECTED_TITLE_COLOR = '#1976d2';
export const FORMAT_OPTION_SELECTED_BODY_COLOR = 'rgba(25, 118, 210, 0.72)';

/** 본문 서식 타일 공통 높이 (라벨 + 미리보기) */
export const FORMAT_OPTION_TILE_MIN_HEIGHT = 190;

/**
 * 템플릿 발송·편집 화면 공통 섹션 — 테두리 + 헤더 바 + 본문
 */
const SubMatTemplateSendSection = ({
  title,
  action = null,
  children,
  sx = {},
  contentSx = {},
}) => (
  <Box
    sx={{
      border: 1,
      borderColor: 'divider',
      borderRadius: 1,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      ...sx,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1,
        // PDF 버튼(small outlined)과 맞춰 헤더 높이 고정 — 목차/미리보기 정렬
        minHeight: 40,
        py: 0.5,
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: SEND_SECTION_HEADER_BG,
        flexShrink: 0,
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center' }}>
        {typeof title === 'string' || typeof title === 'number' ? (
          <Typography variant="subtitle2" component="span" noWrap>
            {title}
          </Typography>
        ) : (
          title
        )}
      </Box>
      {action}
    </Box>
    <Box sx={{ flex: 1, minHeight: 0, ...contentSx }}>
      {children}
    </Box>
  </Box>
);

export default SubMatTemplateSendSection;
